import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import React__default, { useMemo } from 'react';
import { Tooltip as Tooltip$1 } from 'react-tooltip';
import classNames from 'classnames';
import { v4 } from 'uuid';
import { Portal } from '../Portal/Portal.es.js';

const Tooltip = ({ anchorId, onDark = false, size = 'default', width = 'default', openEvent = 'mouseenter', closeEvents = [
    'mouseleave'
], className, children, content, ...props })=>{
    // Auto-generate id when not provided
    const id = useMemo(()=>anchorId ?? 'tooltip-' + v4(), [
        anchorId
    ]);
    return jsxs(Fragment, {
        children: [
            /*#__PURE__*/ React__default.isValidElement(children) ? /*#__PURE__*/ React__default.cloneElement(children, {
                'data-tooltip-id': id
            }) : null,
            jsx(Portal, {
                children: jsx(Tooltip$1, {
                    ...props,
                    "aria-describedby": id,
                    "aria-hidden": "false",
                    className: classNames('cb-tooltip', {
                        dark: onDark,
                        light: !onDark
                    }, className, 'rounded', `size-${size}`, `width-${width}`),
                    closeEvents: closeEvents.reduce((acc, event)=>({
                            ...acc,
                            [event]: true
                        }), {}),
                    id: id,
                    openEvents: {
                        [openEvent]: true
                    },
                    clickable: true,
                    children: content
                })
            })
        ]
    });
};
Tooltip.displayName = 'Tooltip';

export { Tooltip, Tooltip as default };
//# sourceMappingURL=Tooltip.es.js.map
